import Vue from 'vue';

async function createApp({ layouts = {}, options = {}, plugins = [] }) {
  const app = {
    data() {
      return {
        layout: null,
      };
    },
    methods: {
      setLayout(layout) {
        if (!layout || !layouts[layout]) {
          layout = 'default';
        }

        this.layout = layouts[layout];
      },
    },
    render(h) {
      return h(this.layout || 'router-view');
    },
    ...options,
  };

  app.context = { app };
  Object.keys(options).forEach((key) => {
    app.context['$' + key] = options[key];
  });

  function inject(key, value) {
    key = '$' + key;
    app[key] = value;
    app.context[key] = value;
    Vue.use(() => {
      Object.defineProperty(Vue.prototype, key, {
        get() { return this.$root.$options[key]; },
      });
    });
  }

  for (let i = 0; i < plugins.length; i++) {
    const plugin = plugins[i];

    if (typeof plugin === 'function') {
      await plugin(app.context, inject);
    }
  }

  return app;
}

function mountApp(app) {
  const appInst = new Vue(app);
  appInst.setLayout('default');
  appInst.$mount('#app');

  app.router.afterEach((to) => {
    const Component = Vue.extend(to.matched[0].components.default);
    const layout = Component.options.layout;
    appInst.setLayout(typeof layout === 'function' ? layout(app.context) : layout);
  });
}

export default async (options) => {
  const errorHandler = Vue.config.errorHandler || console.error; // eslint-disable-line
  return createApp(options).then(mountApp).catch(errorHandler);
};
